import React from 'react';
import YesNoRadio from '../yes-no-radio';
import { AddFunnelPropFromContext } from '../funnel-context';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
const internationalWorkersFieldLabel = 'Do you have an Australian postal address?';
const LABELS = {
  ARHI: DEFAULT_LABELS.AUS_MAILING_ADDRESS_RADIO,
  IMAN: internationalWorkersFieldLabel,
  IWHI: internationalWorkersFieldLabel
};
const AusMailingAddressRadio = props => {
  const {
    funnel = FUNNELS.ARHI
  } = props;
  return React.createElement(YesNoRadio, {
    ...props,
    funnel: funnel,
    label: props.label || LABELS[funnel] || LABELS.ARHI
  });
};
const AusMailingAddressRadioWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(AusMailingAddressRadio, {
  ...props
}));
export default AusMailingAddressRadioWithFunnel;